export enum PushNotificationTypeEnum {
  RECURRING = "Recurring",
  ONE_TIME = "OneTime",
  INSTANT = "Instant",
}
